"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _card_component = require("../global_components/card_component");

var _card_component2 = _interopRequireDefault(_card_component);

var _reactIntl = require("react-intl");

var _table_component = require("../global_components/table_component");

var _table_component2 = _interopRequireDefault(_table_component);

var _ramda = require("ramda");

var _string_utility = require("../../../../packages/common-utilities/src/string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _number_utility = require("../../../../packages/common-utilities/src/number_utility");

var _number_utility2 = _interopRequireDefault(_number_utility);

var _functional_utility = require("../../../../packages/common-utilities/src/functional_utility");

var _date_formatter = require("../../../../packages/common-utilities/src/date_formatter");

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _collection_utility = require("common-utilities/src/collection_utility");

var _ic_fund_overview = require("./ic_fund_overview");

var _ic_fund_overview2 = _interopRequireDefault(_ic_fund_overview);

var _funds_repository = require("../../repository/funds_repository");

var _funds_repository2 = _interopRequireDefault(_funds_repository);

var _ic_growth_of_hypo_chart_parent = require("./ic_growth_of_hypo_chart_parent");

var _ic_growth_of_hypo_chart_parent2 = _interopRequireDefault(_ic_growth_of_hypo_chart_parent);

var _tracking_utility = require("../../../../packages/common-utilities/src/tracking_utility");

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _ic_auto_suggestion = require("./ic_auto_suggestion");

var _ic_auto_suggestion2 = _interopRequireDefault(_ic_auto_suggestion);

var _accessibility_utility = require("../../../../packages/common-utilities/src/accessibility_utility");

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

var _click_or_escape_outside = require("../click_or_escape_outside");

var _click_or_escape_outside2 = _interopRequireDefault(_click_or_escape_outside);

var _focusTrapReact = require("focus-trap-react");

var _focusTrapReact2 = _interopRequireDefault(_focusTrapReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var URL_CONTINUE_TO_ANALYSIS = "/tools/dt-ic/instruments/npe/";
var URL_IC_TOOL = "/tools/dt-ic/instruments/npe/";
var URL_SIGNUP = "/us/en/asset-management/adv/auth/login-form/#item1";

var IcWidget = function (_React$Component) {
  _inherits(IcWidget, _React$Component);

  function IcWidget(props) {
    _classCallCheck(this, IcWidget);

    var _this = _possibleConstructorReturn(this, (IcWidget.__proto__ || Object.getPrototypeOf(IcWidget)).call(this, props));

    _this.trackRemoveGAEvent = function (_ref, src) {
      var _ref$ticker = _ref.ticker,
          ticker = _ref$ticker === undefined ? '' : _ref$ticker,
          _ref$fundName = _ref.fundName,
          fundName = _ref$fundName === undefined ? '' : _ref$fundName;

      if (!ticker || !fundName) {
        return;
      }

      _tracking_utility.TrackingUtility.trackEvent({
        'eventCategory': 'investment comparison modal',
        'eventAction': src === 'Sticky header' ? 'Sticky header - Remove fund' : 'Remove fund',
        'eventLabel': ticker + " - " + fundName
      });
    };

    _this.trackAddGAEvent = function (src) {
      _tracking_utility.TrackingUtility.trackEvent({
        'eventCategory': 'investment comparison modal',
        'eventAction': src,
        'eventLabel': 'Add a fund'
      });
    };

    _this.trackCancelSearchGAEvent = function () {
      _tracking_utility.TrackingUtility.trackEvent({
        'eventCategory': 'investment comparison modal',
        'eventAction': 'Sticky header',
        'eventLabel': '(x) Cancel'
      });
    };

    _this.trackSearchGAEvent = function () {
      var evt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var inputValue = (0, _functional_utility.pathOrNull)(['target', 'value'], evt);
      if (!inputValue) {
        return;
      }
      _tracking_utility.TrackingUtility.trackEvent({
        'eventCategory': 'investment comparison modal',
        'eventAction': 'search',
        'eventLabel': inputValue
      });
    };

    _this.trackOutsideWidgetGAEvent = function () {
      _tracking_utility.TrackingUtility.trackEvent({
        'event': 'gaEvent',
        'eventCategory': 'investment comparison modal',
        'eventAction': 'close modal',
        'eventLabel': 'Outside modal'
      });
    };

    _this.trackCloseGAEvent = function () {
      _tracking_utility.TrackingUtility.trackEvent({
        'event': 'gaEvent',
        'eventCategory': 'investment comparison modal',
        'eventAction': 'close modal',
        'eventLabel': 'Close button(X)'
      });
    };

    _this.renderFundSearch = _this.renderFundSearch.bind(_this);
    _this.autoSuggest = _this.autoSuggest.bind(_this);
    _this.addingFund = _this.addingFund.bind(_this);
    _this.renderAutoSuggestionResult = _this.renderAutoSuggestionResult.bind(_this);
    _this.renderStickyProductSelectorSection = _this.renderStickyProductSelectorSection.bind(_this);
    _this.renderFundsOverview = _this.renderFundsOverview.bind(_this);
    _this.renderPerformanceAndMorningstarRanks = _this.renderPerformanceAndMorningstarRanks.bind(_this);
    _this.renderStatistics = _this.renderStatistics.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.invokeFundSelector = _this.invokeFundSelector.bind(_this);
    _this.invokeFundDelete = _this.invokeFundDelete.bind(_this);
    _this.updateAddPillStatus = _this.updateAddPillStatus.bind(_this);
    _this.renderIcon = _this.renderIcon.bind(_this);
    _this.closeDisclosurePopup = _this.closeDisclosurePopup.bind(_this);

    _this.fundInput = _react2.default.createRef();
    _this.state = {
      data: [],
      autoCompleteData: [],
      figiIDs: [],
      searchText: '',
      showFundSearch: false,
      inProgressingPillIndex: -1,
      addPillInProgress: false,
      isDialogVisible: false
    };
    return _this;
  }

  _createClass(IcWidget, [{
    key: "renderIcon",
    value: function renderIcon(disclosure, dataTest) {
      var _this2 = this;

      var _props = this.props,
          breakpoint = _props.breakpoint,
          tooltip = _props.tooltip;

      if ((0, _functional_utility.isNilOrEmpty)(disclosure)) {
        return null;
      }

      var filteredDisclosures = disclosure.filter(function (d) {
        return !(0, _ramda.isNil)(d);
      });

      return _react2.default.createElement(
        "span",
        { id: "disclosure-" + dataTest,
          tabIndex: 0,
          ref: function ref(el) {
            return _this2[dataTest] = el;
          },
          className: "padding-left-4 icon-info print-hide vertical-align-top",
          role: "tooltip",
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this2, event, _this2.handleDisclosureIconClick.bind(_this2, event, dataTest, disclosure, tooltip, breakpoint, filteredDisclosures));
          },
          onClick: function onClick(event) {
            return _this2.handleDisclosureIconClick(event, dataTest, disclosure, tooltip, breakpoint, filteredDisclosures);
          }
        },
        " "
      );
    }
  }, {
    key: "handleDisclosureIconClick",
    value: function handleDisclosureIconClick(event, dataTest, disclosure, tooltip, breakpoint, filteredDisclosures) {
      var el = this[dataTest];
      var elHeight = el.offsetHeight;
      var elWidth = el.parentNode.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

      var toolTipWidth = void 0,
          toolTipContentWidth = void 0,
          closeTipPosition = void 0,
          toolTipContentScroll = 'hidden';
      if (disclosure[0].length > 380) {
        if (breakpoint > 3) {
          elWidth -= 150;
          toolTipWidth = 570;
          toolTipContentWidth = 530;
          closeTipPosition = 530;
        } else {
          toolTipContentScroll = 'auto';
        }
      }
      if (breakpoint <= 3) {
        toolTipContentScroll = 'auto';
      }
      var elOffset = {
        top: elRect.top + docTop + arrowHeight + elHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - 3,
        toolTipWidth: toolTipWidth,
        toolTipContentWidth: toolTipContentWidth,
        closeTipPosition: closeTipPosition,
        toolTipContentScroll: toolTipContentScroll,
        zIndex: 100001,
        background: '#fff'
      };

      tooltip.openTooltip(elOffset, filteredDisclosures, null, true, event);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.icWidgetHeading && prevProps.open !== this.props.open && this.props.open) {
        this.icWidgetHeading.focus();
        this.setState({ isDialogVisible: true });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      this.inputOnChangeSubject = new _rxjs.Subject();
      this.inputOnChangeSubscription = this.inputOnChangeSubject.pipe((0, _operators.map)(_ramda.trim), (0, _operators.debounceTime)(150), (0, _operators.distinctUntilChanged)(), (0, _operators.filter)(function (searchText) {
        return !(0, _functional_utility.isNilOrEmpty)(searchText);
      })).subscribe(function (searchText) {
        _funds_repository2.default.getICLiteAutoCompleteData(searchText, _this3.props.country, _this3.props.language, _this3.props.currencyCode, _this3.props.gaiaRedirectUrl + '/ic-autocomplete').then(function (result) {
          if (!(0, _functional_utility.isNilOrEmpty)(result) && result.length > 5) {
            result = result.slice(0, 5);
          }
          _this3.setState({ autoCompleteData: result });
        }, function () {
          return _this3.setState({ icMessageStatus: 'ic error on autocomplete' });
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.inputOnChangeSubscription) {
        this.inputOnChangeSubscription.unsubscribe();
      }
    }
  }, {
    key: "invokeFundSelector",
    value: function invokeFundSelector(index, src) {
      var _this4 = this;

      this.trackAddGAEvent(src);
      this.setState({
        inProgressingPillIndex: index,
        showFundSearch: true,
        searchText: ''
      }, function () {
        _this4.fundInput.focus();
        _this4.inputOnChangeSubject.next('');
      });
    }
  }, {
    key: "invokeFundDelete",
    value: function invokeFundDelete(index, src) {
      var _this5 = this;

      var figiIDs = (0, _ramda.remove)(index, 1, this.state.figiIDs);
      this.trackRemoveGAEvent({
        ticker: (0, _functional_utility.pathOrNull)(['data', index, 'stats', 'categoryStats', 'funds', 0, 'ticker'], this.state),
        fundName: (0, _functional_utility.pathOrNull)(['data', index, 'basicInfo', 'name'], this.state)
      }, src);

      _funds_repository2.default.getICLiteProductData(this.props.country, this.props.language, this.props.role, this.props.currencyCode, this.props.gaiaRedirectUrl + '/ic-product-comparison', figiIDs).then(function (icFundState) {
        _this5.setState({
          data: icFundState.comparisonData,
          figiIDs: figiIDs
        });
      }, function () {
        _this5.setState({ icMessageStatus: 'ic error' });
      });
    }
  }, {
    key: "cancelFundSearch",
    value: function cancelFundSearch() {
      this.trackCancelSearchGAEvent();
      this.setState({
        autoCompleteData: [],
        showFundSearch: false,
        inProgressingPillIndex: -1,
        searchText: ''
      });
      this.inputOnChangeSubject.next('');
    }
  }, {
    key: "addingFund",
    value: function addingFund(newFigiId) {
      var _this6 = this;

      if (this.state.inProgressingPillIndex > 0 && !(0, _functional_utility.isNilOrEmpty)(newFigiId)) {
        var figiIDs = this.state.figiIDs;
        figiIDs[this.state.inProgressingPillIndex] = newFigiId;

        _funds_repository2.default.getICLiteProductData(this.props.country, this.props.language, this.props.role, this.props.currencyCode, this.props.gaiaRedirectUrl + '/ic-product-comparison', figiIDs).then(function (icFundState) {
          _this6.setState({
            data: icFundState.comparisonData,
            figiIDs: figiIDs,
            autoCompleteData: [],
            showFundSearch: false,
            inProgressingPillIndex: -1,
            searchText: ''
          });
          _this6.inputOnChangeSubject.next('');
        }, function () {
          _this6.setState({ icMessageStatus: 'ic error' });
        });
      }
    }
  }, {
    key: "updateAddPillStatus",
    value: function updateAddPillStatus(e) {
      if (!(0, _functional_utility.isNilOrEmpty)(e.target.value)) {
        this.setState({ addPillInProgress: true });
      } else {
        this.setState({ addPillInProgress: false });
      }
    }
  }, {
    key: "autoSuggest",
    value: function autoSuggest(e) {
      this.setState({ searchText: e.target.value });
      this.inputOnChangeSubject.next(e.target.value);
    }
  }, {
    key: "renderAutoSuggestionResult",
    value: function renderAutoSuggestionResult() {
      return _react2.default.createElement(_ic_auto_suggestion2.default, {
        addingFund: this.addingFund,
        figiIDs: this.state.figiIDs,
        autoCompleteData: this.state.autoCompleteData
      });
    }
  }, {
    key: "renderStickyProductSelectorSection",
    value: function renderStickyProductSelectorSection() {
      var _this7 = this;

      return _react2.default.createElement(
        "div",
        { className: "ic-lite-header" },
        this.state.showFundSearch && this.renderFundSearch(),
        !this.state.showFundSearch && _react2.default.createElement(
          "div",
          { className: "padding-horizontal-50 padding-vertical-16 height-90", "data-testid": "ic-lite-text" },
          _react2.default.createElement(
            "div",
            { className: "ic-lite-text tag-2" },
            _react2.default.createElement(
              "h2",
              {
                ref: function ref(el) {
                  return _this7.icWidgetHeading = el;
                },
                tabIndex: "0",
                id: "dialog-label", className: "display-inline-block" },
              _string_utility2.default.getLocalizedString(this.props.intl, "Investment Comparison", "ic-lite")
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "ic-lite-text sub-header-3" },
            _react2.default.createElement(
              "span",
              {
                className: "font-white" },
              _string_utility2.default.renderFormattedLabel("Quickly compare up to 3 funds", "ic-quicl-compare")
            ),
            this.renderPickedTickerOrAddNewPill(true)
          )
        )
      );
    }
  }, {
    key: "renderFundSearch",
    value: function renderFundSearch() {
      var _this8 = this;

      return _react2.default.createElement(
        "div",
        { className: "ic-fund-search-section", "data-testid": "ic-fund-search-section" },
        _react2.default.createElement(
          "div",
          { className: "row padding-vertical-40 padding-horizontal-50" },
          _react2.default.createElement("div", { className: "ic-search-icon col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xlg-1 height-130" }),
          _react2.default.createElement(
            "div",
            { className: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xlg-6 height-50" },
            _react2.default.createElement(
              "label",
              { htmlFor: "ic-fund-search-input", className: 'ic-search-input-label disclaimer' },
              _string_utility2.default.getLocalizedString(this.props.intl, "Search investments", "pdp-ic-fund-search-label")
            ),
            _react2.default.createElement("input", { type: "text",
              id: "ic-fund-search-input",
              autoComplete: "off",
              "data-testid": "ic-fund-search-input",
              ref: function ref(el) {
                return _this8.fundInput = el;
              },
              placeholder: _string_utility2.default.getLocalizedString(this.props.intl, "Type ticker or investment name", "pdp-ic-fund-search-placeholder"),
              className: "ic-fund-search-input height-38 sub-header-3 padding-vertical-12 padding-left-16 padding-right-20 border-all-1 border-radius-4 border-warm-grey",
              onChange: this.autoSuggest,
              onKeyUp: this.updateAddPillStatus,
              onBlur: this.trackSearchGAEvent
            })
          ),
          this.renderPickedTickerOrAddNewPill(false)
        ),
        _react2.default.createElement(
          "div",
          { className: 'sr-only', "aria-live": "polite" },
          this.state.autoCompleteData.length,
          " funds found"
        ),
        _react2.default.createElement(
          "div",
          { id: "ic-suggestion", className: "ic-suggestion", "data-testid": "ic-suggestion", "aria-live": "polite"
          },
          this.renderAutoSuggestionResult()
        ),
        _react2.default.createElement(
          "div",
          { tabIndex: 0, className: "ic-fund-search-cancel height-50", "data-testid": "ic-fund-search-cancel",
            onKeyDown: function onKeyDown(event) {
              return _accessibility_utility2.default.handleEnterClick(_this8, event, _this8.cancelFundSearch.bind(_this8, event));
            },
            onClick: function onClick() {
              return _this8.cancelFundSearch();
            } },
          _react2.default.createElement(
            "span",
            { className: "font-white tag" },
            _string_utility2.default.renderFormattedLabel("Cancel", "pdp-ic-fund-search-cancel")
          )
        )
      );
    }
  }, {
    key: "renderPickedTickerOrAddNewPill",
    value: function renderPickedTickerOrAddNewPill(isSticky) {
      var _this9 = this;

      var tickerClass = isSticky ? "ic-ticker-area-sticky pull-right" : "ic-ticker-area";
      var pickedTickerOrAddNewPill = [];
      var tickers = [];
      this.state.data.forEach(function (data) {
        tickers.push(data.stats.categoryStats.funds[0].ticker);
      });
      var onlyOneSelected = tickers.length === 1;

      var _loop = function _loop(index) {
        if (!(0, _functional_utility.isNilOrEmpty)(tickers[index])) {
          pickedTickerOrAddNewPill.push(_react2.default.createElement(
            "button",
            {
              type: "button",
              className: "" + (_this9.state.showFundSearch || onlyOneSelected ? "ic-ticker-pill-no-hover" : "ic-ticker-pill"),
              tabIndex: "" + (_this9.state.showFundSearch ? -1 : 0),
              "aria-describedby": tickers[index],
              onKeyDown: function onKeyDown(event) {
                return _accessibility_utility2.default.handleEnterClick(_this9, event, _this9.invokeFundDelete.bind(_this9, index, 'Sticky header'));
              }
            },
            _react2.default.createElement(
              "span",
              { className: "ic-select-ticker-text body2", id: tickers[index] },
              tickers[index]
            ),
            !_this9.state.showFundSearch && !onlyOneSelected && _react2.default.createElement(
              "div",
              { className: "ic-remove-text body2",
                onClick: function onClick() {
                  return _this9.invokeFundDelete(index, 'Sticky header');
                }
              },
              "Remove"
            )
          ));
          pickedTickerOrAddNewPill.push(_react2.default.createElement("div", { className: "ic-versus-icon" }));
        } else if (_this9.state.showFundSearch && index === _this9.state.inProgressingPillIndex) {
          pickedTickerOrAddNewPill.push(_react2.default.createElement(
            "div",
            { className: "ic-add-pill " + (_this9.state.showFundSearch ? "disabled" : "") + " text-center" },
            _react2.default.createElement("span", { className: "ic-add-pill-in-progress-icon", style: _this9.state.addPillInProgress ? { "display": "inline-block" } : { "display": "none" } })
          ));
          pickedTickerOrAddNewPill.push(_react2.default.createElement("div", { className: "ic-versus-icon" }));
        } else if (tickers.length === 1 && index === 1 || tickers.length === 2 && index === 2) {
          pickedTickerOrAddNewPill.push(_react2.default.createElement(
            "button",
            { className: "ic-add-pill-default text-center", type: "button", "aria-label": "Add",
              tabIndex: "0",
              onClick: function onClick() {
                return _this9.invokeFundSelector(index, 'Sticky header');
              },
              onKeyDown: function onKeyDown(event) {
                return _accessibility_utility2.default.handleEnterClick(_this9, event, _this9.invokeFundSelector.bind(_this9, index, 'Sticky header'));
              }
            },
            _react2.default.createElement("span", { className: "ic-add-pill-icon" }),
            _react2.default.createElement(
              "span",
              { className: "ic-add-text body2" },
              "Add fund"
            )
          ));
          pickedTickerOrAddNewPill.push(_react2.default.createElement("div", { className: "ic-versus-icon" }));
        } else {
          pickedTickerOrAddNewPill.push(_react2.default.createElement("div", { className: "ic-inactive-pill" }));
          pickedTickerOrAddNewPill.push(_react2.default.createElement("div", { className: "ic-versus-icon" }));
        }
      };

      for (var index = 0; index < 3; index++) {
        _loop(index);
      }
      pickedTickerOrAddNewPill.pop();
      return _react2.default.createElement(
        "div",
        { className: tickerClass + " tag" },
        pickedTickerOrAddNewPill
      );
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(event) {
      if (!this.state.showFundSearch) {
        if (event.currentTarget.scrollTop >= document.getElementsByClassName("ic-fund-overview-container")[0].clientHeight - document.getElementsByClassName("ic-lite-header")[0].clientHeight) {
          document.getElementsByClassName("ic-ticker-area-sticky")[0].style.display = "flex";
        } else {
          document.getElementsByClassName("ic-ticker-area-sticky")[0].style.display = "none";
        }
      }
      this.closeDisclosurePopup();
    }
  }, {
    key: "closeDisclosurePopup",
    value: function closeDisclosurePopup() {
      if (!(0, _ramda.isNil)(this.props.tooltip)) {
        this.props.tooltip.closeTooltip();
      }
    }
  }, {
    key: "renderFundsOverview",
    value: function renderFundsOverview() {
      return _react2.default.createElement(
        "div",
        { className: "font-super-black ic-fund-overview-container" },
        _react2.default.createElement(_ic_fund_overview2.default, { data: this.state.data,
          intl: this.props.intl,
          breakpoint: this.props.breakpoint,
          disclosureText: null,
          invokeFundSelector: this.invokeFundSelector.bind(this),
          invokeFundDelete: this.invokeFundDelete.bind(this) })
      );
    }
  }, {
    key: "renderTickerRow",
    value: function renderTickerRow(labelKey, val1, val2, val3) {
      return _react2.default.createElement(
        "tr",
        { "data-testid": labelKey + "-row", id: labelKey + "-row",
          className: 'category ic-statistics-sub-header',
          key: labelKey + "-key" },
        _react2.default.createElement("td", { key: "0" }),
        _react2.default.createElement(
          "th",
          { scope: "col", key: "1", className: "body-bold text-right min-width-198",
            style: { "padding": "10 20 10 0" }, "data-testid": "labelKey-value1" },
          (0, _ramda.isNil)(val1) ? '-' : val1
        ),
        _react2.default.createElement(
          "th",
          { scope: "col", key: "2",
            className: "body-bold text-right min-width-198",
            style: { "padding": "10 20 10 0" }, "data-testid": "labelKey-value2" },
          (0, _ramda.isNil)(val2) ? '-' : val2
        ),
        _react2.default.createElement(
          "th",
          { scope: "col", key: "3",
            className: "body-bold text-right min-width-198",
            style: { "padding": "10 20 10 0" }, "data-testid": "labelKey-value3" },
          (0, _ramda.isNil)(val3) ? '-' : val3
        )
      );
    }
  }, {
    key: "renderPerformanceTickerRow",
    value: function renderPerformanceTickerRow(labelKey, val1, val2, val3) {
      return _react2.default.createElement(
        "tr",
        { "data-testid": labelKey + "-row", id: labelKey + "-row",
          className: 'category ic-performance-sub-header',
          key: labelKey + "-key" },
        _react2.default.createElement("td", { key: "0" }),
        _react2.default.createElement("td", { key: "1" }),
        _react2.default.createElement(
          "th",
          { key: "2", scope: "col", className: "body-bold text-right min-width-198",
            style: { "padding": "10 20 10 0" }, "data-testid": "labelKey-value1" },
          (0, _ramda.isNil)(val1) ? '-' : val1
        ),
        _react2.default.createElement(
          "th",
          { key: "3", scope: "col",
            className: "body-bold text-right min-width-198",
            style: { "padding": "10 20 10 0" }, "data-testid": "labelKey-value2" },
          (0, _ramda.isNil)(val2) ? '-' : val2
        ),
        _react2.default.createElement(
          "th",
          { key: "4", scope: "col",
            className: "body-bold text-right min-width-198",
            style: { "padding": "10 20 10 0" }, "data-testid": "labelKey-value3" },
          (0, _ramda.isNil)(val3) ? '-' : val3
        )
      );
    }
  }, {
    key: "renderPerformanceRow",
    value: function renderPerformanceRow(labelKey, yearLabel, val1, val2, val3) {
      return _react2.default.createElement(
        "tr",
        { "data-testid": labelKey + "-performance-row", id: labelKey + "-performance-row",
          className: 'category row-divider ic-performance-row',
          key: labelKey + "-performance-key" },
        _react2.default.createElement(
          "th",
          { key: "0", rowSpan: 2, scope: "rowgroup", className: "text-left body-bold",
            "data-testid": labelKey + "-performance-row" },
          yearLabel
        ),
        _react2.default.createElement(
          "th",
          { key: "1", scope: "row", className: "text-left category",
            "data-testid": "return-performance-row" },
          _string_utility2.default.renderFormattedLabel("Return", "ic-performance-return-label")
        ),
        _react2.default.createElement(
          "td",
          { key: "2", className: "text-right min-width-198", style: { "padding-right": 20 },
            "data-testid": yearLabel + "-performance-value1" },
          val1
        ),
        _react2.default.createElement(
          "td",
          { key: "3", className: "text-right min-width-198", style: { "padding-right": 20 },
            "data-testid": yearLabel + "-performance-value2" },
          (0, _ramda.isNil)(val2) ? '-' : val2
        ),
        _react2.default.createElement(
          "td",
          { key: "4", className: "text-right min-width-198", style: { "padding-right": 20 },
            "data-testid": yearLabel + "-performance-value3" },
          (0, _ramda.isNil)(val3) ? '-' : val3
        )
      );
    }
  }, {
    key: "renderRankRow",
    value: function renderRankRow(yearLabel, val1, val2, val3) {
      return _react2.default.createElement(
        "tr",
        { "data-testid": yearLabel + "-rank-row", id: yearLabel + "-rank-row",
          className: 'category row-divider ic-performance-row',
          key: yearLabel + "-rank-key" },
        _react2.default.createElement(
          "th",
          { key: "1", scope: "row", className: "text-left category",
            "data-testid": "return-rank-row" },
          _string_utility2.default.renderFormattedLabel("% Rank", "ic-rank-return-label")
        ),
        _react2.default.createElement(
          "td",
          { key: "2", className: "text-right min-width-198",
            style: { "padding-right": 20, "backgroundColor": this.getRankColor(val1) },
            "data-testid": yearLabel + "-rank-value1" },
          val1
        ),
        _react2.default.createElement(
          "td",
          { key: "3", className: "text-right min-width-198",
            style: { "padding-right": 20, "backgroundColor": this.getRankColor(val2) },
            "data-testid": yearLabel + "-rank-value2" },
          (0, _ramda.isNil)(val2) ? '-' : val2
        ),
        _react2.default.createElement(
          "td",
          { key: "4", className: "text-right min-width-198",
            style: { "padding-right": 20, "backgroundColor": this.getRankColor(val3) },
            "data-testid": yearLabel + "-rank-value3" },
          (0, _ramda.isNil)(val3) ? '-' : val3
        )
      );
    }
  }, {
    key: "getRankColor",
    value: function getRankColor(rankValue) {
      var rankColor = "";
      var value = parseInt(rankValue);
      switch (true) {
        case value > 0 && value < 26:
          rankColor = "#B7DE6F";
          break;
        case value > 25 && value < 51:
          rankColor = "#FFD57D";
          break;
        case value > 50 && value < 76:
          rankColor = "#FFA459";
          break;
        case value > 75 && value < 101:
          rankColor = "#FF8A8A";
          break;
      }
      return rankColor;
    }
  }, {
    key: "renderHeaderTitleWithAsOfDate",
    value: function renderHeaderTitleWithAsOfDate(key, defaultTitle, asOfDate) {
      return _react2.default.createElement(
        "span",
        null,
        _string_utility2.default.renderFormattedLabel(defaultTitle, key + "-title"),
        " ",
        _react2.default.createElement(
          "span",
          { className: "category" },
          _string_utility2.default.renderFormattedLabel("As of", "label-for-as-of"),
          " ",
          asOfDate
        )
      );
    }
  }, {
    key: "getPerformanceMorningstarRanksLegend",
    value: function getPerformanceMorningstarRanksLegend() {
      return _react2.default.createElement(
        "span",
        { className: "pull-right disclaimer margin-top--25" },
        _string_utility2.default.renderFormattedLabel("Top quartile", "ic-top-quartile-label"),
        _react2.default.createElement("span", { className: "ic-legend-dot-green padding-left-16 padding-right-4" }),
        _react2.default.createElement("span", { className: "ic-legend-dot-yellow padding-left-8 padding-right-8" }),
        _react2.default.createElement("span", { className: "ic-legend-dot-orange padding-left-8 padding-right-8" }),
        _react2.default.createElement("span", { className: "ic-legend-dot-red padding-left-4 padding-right-16" }),
        _string_utility2.default.renderFormattedLabel("Bottom quartile", "ic-bottom-quartile-label"),
        this.renderIcon([_string_utility2.default.getLocalizedString(this.props.intl, 'Performance & Morningstar Disclosure', "ic-performance-morningstar-popup-disclosure")], "ic-performance-popup-disclosure")
      );
    }
  }, {
    key: "renderPerformanceAndMorningstarRanks",
    value: function renderPerformanceAndMorningstarRanks() {
      var asOfDate = _date_formatter2.default.getDateInSlashFormat(this.state.data[0].stats.asOfDate);
      return _react2.default.createElement(
        "div",
        { className: "" },
        _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: this.renderHeaderTitleWithAsOfDate("ic-performance-morningstar", "Performance & Morningstar Ranks", asOfDate),
            headerTitleId: "ic-performance-morningstar-ranks",
            headerTitleLabel: "ic-performance-morningstar-ranks-header",
            headerLabel: this.getPerformanceMorningstarRanksLegend(),
            headerTagLevel: '3',
            disclosureText: [_string_utility2.default.getLocalizedString(this.props.intl, 'Performance & Morningstar Disclosure', "ic-performance-morningstar-disclosure")],
            placementId: null,
            breakpoint: this.props.breakpoint,
            hideCardBorder: true,
            ariaLabel: "Read more about Performance & Morningstar Ranks"
          },
          _react2.default.createElement(_table_component2.default, {
            tableRows: this.getPerformanceAndMorningstarRanksTable(),
            tableHeadersStyle: { "textAlign": "right" },
            breakpoint: this.props.breakpoint,
            ariaLabelledby: "ic-performance-morningstar-ranks"
          })
        )
      );
    }
  }, {
    key: "getPerformanceAndMorningstarRanksTable",
    value: function getPerformanceAndMorningstarRanksTable() {
      var data = this.formatMorningstarAndPerformanceData();
      var tableRows = [];
      if ((0, _ramda.isNil)(data[0])) {
        return tableRows;
      }
      tableRows.push(this.renderPerformanceTickerRow('ic-ticker', data[0].ticker, (0, _functional_utility.isNilOrEmpty)(data[1]) ? "-" : data[1].ticker, (0, _functional_utility.isNilOrEmpty)(data[2]) ? "-" : data[2].ticker));
      tableRows.push(this.renderPerformanceRow("oneYear", _string_utility2.default.renderFormattedLabel("1 Year", "ic-performance-1year-label"), data[0].returns.totalReturn1Y, (0, _functional_utility.isNilOrEmpty)(data[1]) ? "-" : data[1].returns.totalReturn1Y, (0, _functional_utility.isNilOrEmpty)(data[2]) ? "-" : data[2].returns.totalReturn1Y));
      tableRows.push(this.renderRankRow("oneYear", data[0].returns.msRank1Y, (0, _ramda.isNil)(data[1]) ? "-" : data[1].returns.msRank1Y, (0, _ramda.isNil)(data[2]) ? "-" : data[2].returns.msRank1Y));
      tableRows.push(this.renderPerformanceRow("fiveYear", _string_utility2.default.renderFormattedLabel("5 Year", "ic-performance-5year-label"), data[0].returns.totalReturn5Y, (0, _functional_utility.isNilOrEmpty)(data[1]) ? "-" : data[1].returns.totalReturn5Y, (0, _functional_utility.isNilOrEmpty)(data[2]) ? "-" : data[2].returns.totalReturn5Y));
      tableRows.push(this.renderRankRow("fiveYear", data[0].returns.msRank5Y, (0, _ramda.isNil)(data[1]) ? "-" : data[1].returns.msRank5Y, (0, _ramda.isNil)(data[2]) ? "-" : data[2].returns.msRank5Y));
      tableRows.push(this.renderPerformanceRow("tenYear", _string_utility2.default.renderFormattedLabel("10 Year", "ic-performance-10year-label"), data[0].returns.totalReturn10Y, (0, _functional_utility.isNilOrEmpty)(data[1]) ? "-" : data[1].returns.totalReturn10Y, (0, _functional_utility.isNilOrEmpty)(data[2]) ? "-" : data[2].returns.totalReturn10Y));
      tableRows.push(this.renderRankRow("tenYear", data[0].returns.msRank10Y, (0, _ramda.isNil)(data[1]) ? "-" : data[1].returns.msRank10Y, (0, _ramda.isNil)(data[2]) ? "-" : data[2].returns.msRank10Y));

      return tableRows;
    }
  }, {
    key: "formatMorningstarAndPerformanceData",
    value: function formatMorningstarAndPerformanceData() {
      var data = [];
      this.state.data.forEach(function (dataObj) {
        var fundData = {};
        var returns = {};
        if (!(0, _functional_utility.isNilOrEmpty)(dataObj.stats.categoryStats.funds[0].returns)) {
          dataObj.stats.categoryStats.funds[0].returns.forEach(function (returnData) {
            returns["totalReturn" + returnData.period] = _number_utility2.default.roundNumber(returnData.totalReturn, 2);
            returns["msRank" + returnData.period] = returnData.msRank;
          });
        }
        fundData["ticker"] = dataObj.stats.categoryStats.funds[0].ticker;
        fundData["returns"] = returns;
        data.push(fundData);
      });
      return data;
    }
  }, {
    key: "renderStatistics",
    value: function renderStatistics() {
      var asOfDate = _date_formatter2.default.getDateInSlashFormat(this.state.data[0].stats.asOfDate);
      var disclosure = _string_utility2.default.getLocalizedString(this.props.intl, "", "pdp-ic-statistics-disclosure-text");
      return _react2.default.createElement(
        "div",
        { className: "" },
        _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: this.renderHeaderTitleWithAsOfDate("ic-statistics", "Statistics", asOfDate),
            headerTitleId: "ic-statistics",
            headerTitleLabel: "ic-statistics-header",
            headerTagLevel: '3',
            dataTest: "ic-statistics",
            disclosureText: [disclosure],
            disclosureAdditionalStyle: "font-slate-grey",
            placementId: null,
            breakpoint: this.props.breakpoint,
            headerLabel: null,
            hideCardBorder: true,
            ariaLabel: "Read more about Statistics"
          },
          _react2.default.createElement(_table_component2.default, {
            tableRows: this.getStatisticsTable(),
            tableHeadersStyle: { "textAlign": "right" },
            breakpoint: this.props.breakpoint,
            ariaLabelledby: "ic-statistics"
          })
        )
      );
    }
  }, {
    key: "getStatisticsTable",
    value: function getStatisticsTable() {
      var data = [];
      var asOfDate = this.state.data[0].stats.asOfDate;
      this.state.data.forEach(function (dataObj) {
        var fundData = {};
        fundData["ticker"] = dataObj.stats.categoryStats.funds[0].ticker;
        if (!(0, _ramda.isNil)(dataObj.stats.categoryStats.funds[0]) && !(0, _functional_utility.isNilOrEmpty)(dataObj.stats.categoryStats.funds[0].mptStats)) {
          dataObj.stats.categoryStats.funds[0].mptStats.forEach(function (mptStat) {
            if (mptStat.period === '3Y') {
              fundData["threeYearsSharpeRatio"] = mptStat.sharpeRatio;
              fundData["threeYearsStandardDeviation"] = mptStat.stdDev;
            }
          });
        }
        if (!(0, _functional_utility.isNilOrEmpty)(dataObj.fundYields)) {
          var fundYieldData = dataObj.fundYields;
          fundData["thirtyDaySecYield"] = !(0, _ramda.isNil)(asOfDate) && asOfDate === fundYieldData.secYieldEffectiveDate ? fundYieldData.secYield : null;
          fundData["twelveMonthsYield"] = !(0, _ramda.isNil)(asOfDate) && asOfDate === fundYieldData.twelveMonthYieldEffectiveDate ? fundYieldData.twelveMonthYield : null;
        }
        data.push(fundData);
      });

      var tableRows = [];

      tableRows.push(this.renderTickerRow('ic-ticker', _collection_utility.CollectionUtility.getValueFromArr(data, 0, 'ticker'), _collection_utility.CollectionUtility.getValueFromArr(data, 1, 'ticker'), _collection_utility.CollectionUtility.getValueFromArr(data, 2, 'ticker')));
      tableRows.push(this.renderStatisticsRow('ic-statistics-three-years-sharpe-ratio', "3 years Sharpe ratio", _collection_utility.CollectionUtility.getValueFromArr(data, 0, 'threeYearsSharpeRatio'), _collection_utility.CollectionUtility.getValueFromArr(data, 1, 'threeYearsSharpeRatio'), _collection_utility.CollectionUtility.getValueFromArr(data, 2, 'threeYearsSharpeRatio')));
      tableRows.push(this.renderStatisticsRow('ic-statistics-three-years-standard-deviation', "3 years standard deviation", _collection_utility.CollectionUtility.getValueFromArr(data, 0, 'threeYearsStandardDeviation'), _collection_utility.CollectionUtility.getValueFromArr(data, 1, 'threeYearsStandardDeviation'), _collection_utility.CollectionUtility.getValueFromArr(data, 2, 'threeYearsStandardDeviation')));
      tableRows.push(this.renderStatisticsRow('ic-statistics-thirty-day-sec-yield', "30-day SEC yield", _collection_utility.CollectionUtility.getValueFromArr(data, 0, 'thirtyDaySecYield'), _collection_utility.CollectionUtility.getValueFromArr(data, 1, 'thirtyDaySecYield'), _collection_utility.CollectionUtility.getValueFromArr(data, 2, 'thirtyDaySecYield')));
      tableRows.push(this.renderStatisticsRow('ic-statistics-twelve-months-yield', "12 month yield", _collection_utility.CollectionUtility.getValueFromArr(data, 0, 'twelveMonthsYield'), _collection_utility.CollectionUtility.getValueFromArr(data, 1, 'twelveMonthsYield'), _collection_utility.CollectionUtility.getValueFromArr(data, 2, 'twelveMonthsYield')));

      return tableRows;
    }
  }, {
    key: "renderStatisticsRow",
    value: function renderStatisticsRow(labelKey, rowHeader, val1, val2, val3) {
      return _react2.default.createElement(
        "tr",
        { "data-testid": labelKey + "-row", id: labelKey + "-row",
          className: 'category row-divider ic-statistics-row',
          key: labelKey + "-key" },
        _react2.default.createElement(
          "th",
          { key: "0", scope: "row", className: "text-left ", "data-testid": "labelKey-label-name" },
          rowHeader
        ),
        _react2.default.createElement(
          "td",
          { key: "1", className: "text-right min-width-198", style: { "padding-right": 20 },
            "data-testid": "labelKey-value1" },
          _number_utility2.default.formatToPercentWith2FixedDecimals(val1)
        ),
        _react2.default.createElement(
          "td",
          { key: "2", className: "text-right min-width-198", style: { "padding-right": 20 }, "data-testid": "labelKey-value2" },
          _number_utility2.default.formatToPercentWith2FixedDecimals(val2)
        ),
        _react2.default.createElement(
          "td",
          { key: "3", className: "text-right min-width-198", style: { "padding-right": 20 }, "data-testid": "labelKey-value3" },
          _number_utility2.default.formatToPercentWith2FixedDecimals(val3)
        )
      );
    }
  }, {
    key: "renderGrowthOf10K",
    value: function renderGrowthOf10K() {
      var growthOf10KData = [];
      var stats = [];
      var disabledIndex = [];
      var figiIdsForDownload = [];
      var growthOf10KMonthEnds = [];
      var growthOf10KPeriodView = "";

      this.state.data.forEach(function (dataObj) {
        if (!(0, _ramda.isNil)(dataObj.growthOf10K)) {
          growthOf10KData.push(dataObj.growthOf10K);
          growthOf10KPeriodView = dataObj.growthOf10KPeriodView;
          growthOf10KMonthEnds = dataObj.growthOf10KMonthEnds;
          disabledIndex.push(false);
          figiIdsForDownload.push(dataObj.basicInfo.figiId);
        } else {
          growthOf10KData.push(null);
          disabledIndex.push(true);
        }
        if (!(0, _functional_utility.isNilOrEmpty)(dataObj.stats.categoryStats)) {
          stats.push(dataObj.stats.categoryStats);
        }
      });
      var disclosure = _string_utility2.default.getLocalizedString(this.props.intl, "", "pdp-ic-growth-of-hypo-disclosure-text");

      return _react2.default.createElement(_ic_growth_of_hypo_chart_parent2.default, {
        growthOf10KData: growthOf10KData,
        growthOf10KPeriodView: growthOf10KPeriodView,
        growthOf10KMonthEnds: growthOf10KMonthEnds,
        stats: stats,
        disclosure: disclosure,
        breakpoint: this.props.breakpoint,
        numberFormat: this.props.numberFormat,
        disabledIndex: disabledIndex,
        role: this.props.role,
        gaiaRedirectUrl: this.props.gaiaRedirectUrl,
        country: this.props.country,
        language: this.props.language,
        currency: this.props.currencyCode,
        figiIds: figiIdsForDownload
      });
    }
  }, {
    key: "renderCTASecond",
    value: function renderCTASecond() {
      return _react2.default.createElement(
        "div",
        { className: "padding-horizontal-40 padding-vertical-12 ic-cta-second" },
        _react2.default.createElement(
          "div",
          { className: "ic-cta-second-title", "data-testid": "ic-cta-second-title-icon-container" },
          _react2.default.createElement("div", { className: "row ic-rocket-launch padding-bottom-60" }),
          _react2.default.createElement(
            "h3",
            { className: "row sub-header-2" },
            _string_utility2.default.renderFormattedHTMLLabel("See the full analysis in our free Investment Comparison tool", "ic-cta-second-header")
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row padding-horizontal-120 padding-top-30", "data-testid": "ic-cta-second-columns-container" },
          _react2.default.createElement(
            "ul",
            { className: "ic-cta-wrapper" },
            _react2.default.createElement(
              "li",
              { className: "ic-cta-item" },
              _string_utility2.default.renderFormattedHTMLLabel("Compare up to 6 investments from over 35,000 options", "ic-cta-second-col1-row1")
            ),
            _react2.default.createElement(
              "li",
              { className: "ic-cta-item" },
              _string_utility2.default.renderFormattedHTMLLabel("Stress test funds in various market events", "ic-cta-second-col2-row1")
            ),
            _react2.default.createElement(
              "li",
              { className: "ic-cta-item" },
              _string_utility2.default.renderFormattedHTMLLabel("Download client-ready reports of your analyses", "ic-cta-second-col3-row1")
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row category font-slate-grey", "data-testid": "ic-cta-second-description-container", style: { "text-align": "center" } },
          _string_utility2.default.renderFormattedHTMLLabel("It’s free, simply log in or create an account for instant access to all advanced data & customization features.", "ic-cta-second-description")
        ),
        this.renderCTAButtonByLoginStatus()
      );
    }
  }, {
    key: "renderCTAButtonByLoginStatus",
    value: function renderCTAButtonByLoginStatus() {
      var tickerArray = [];
      this.state.data.forEach(function (data) {
        tickerArray.push(data.stats.categoryStats.funds[0].ticker);
      });

      if (this.props.userLoggedIn) {
        var urlContinueToAnalysis = this.props.cmsHost + URL_CONTINUE_TO_ANALYSIS + (!(0, _functional_utility.isNilOrEmpty)(tickerArray[0]) ? tickerArray[0] : "") + (!(0, _functional_utility.isNilOrEmpty)(tickerArray[1]) ? "," + tickerArray[1] : "") + (!(0, _functional_utility.isNilOrEmpty)(tickerArray[2]) ? "," + tickerArray[2] : "");

        return _react2.default.createElement(
          "div",
          { className: "row", "data-testid": "ic-cta-second-cta-container", style: { "text-align": "center" } },
          _react2.default.createElement(
            "div",
            { className: "ic-cta-button" },
            _react2.default.createElement(
              "a",
              { href: urlContinueToAnalysis, "data-testid": "ic-continue-to-analysis-url",
                id: "ic-continue-to-analysis-url", target: "_blank", "aria-label": "Continue to full analysis",
                onClick: function onClick() {
                  _tracking_utility.TrackingUtility.trackEvent({
                    'eventCategory': 'investment comparison modal',
                    'eventAction': 'button',
                    'eventLabel': 'Continue to full analysis'
                  });
                }
              },
              _react2.default.createElement(
                "div",
                { "data-testid": "btn-continue-to-analysis", id: "btn-continue-to-analysis",
                  className: "standardButton button margin-bottom-20 margin-top-10 col-md-4 col-lg-3 col-xlg-3 print-hide" },
                _react2.default.createElement(
                  "div",
                  { className: "downloadButtonText padding-horizontal-14 ic-cta-button" },
                  _string_utility2.default.renderFormattedLabel("Continue to full analysis", "ic-cta-continue-to-full-analysis")
                )
              )
            )
          )
        );
      } else {
        return _react2.default.createElement(
          "div",
          { className: "row", "data-testid": "ic-cta-second-cta-container", style: { "text-align": "center" } },
          _react2.default.createElement(
            "div",
            { className: "ic-cta-button" },
            _react2.default.createElement(
              "a",
              { href: this.props.cmsHost + URL_IC_TOOL + _string_utility2.default.concatNonEmptyStrings(tickerArray, ","), "data-testid": "ic-login-url",
                id: "ic-login-url", target: "_blank", "aria-label": "Log in now to continue",
                onClick: function onClick() {
                  _tracking_utility.TrackingUtility.trackEvent({
                    'eventCategory': 'investment comparison modal',
                    'eventAction': 'button',
                    'eventLabel': 'Log in to continue'
                  });
                } },
              _react2.default.createElement(
                "div",
                { "data-testid": "btn-login-to-continue", id: "btn-login-to-continue",
                  className: "standardButton button margin-bottom-20 margin-top-10 col-md-4 col-lg-3 col-xlg-3 print-hide" },
                _react2.default.createElement(
                  "div",
                  { className: "downloadButtonText padding-horizontal-14 ic-cta-button" },
                  _string_utility2.default.renderFormattedLabel("Log in to continue", "ic-cta-login-to-continue")
                )
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "ic-cta-button" },
            _react2.default.createElement(
              "a",
              { href: this.props.cmsHost + URL_SIGNUP,
                "data-testid": "ic-signup-url", id: "ic-signup-url", target: "_self",
                onClick: function onClick() {
                  _tracking_utility.TrackingUtility.trackEvent({
                    'eventCategory': 'investment comparison modal',
                    'eventAction': 'button',
                    'eventLabel': 'Sign up'
                  });
                }
              },
              _react2.default.createElement(
                "div",
                { "data-testid": "btn-signup", id: "btn-signup",
                  className: "standardButton button background-white margin-bottom-20 margin-top-10 col-md-4 col-lg-3 col-xlg-3 print-hide" },
                _react2.default.createElement(
                  "div",
                  { className: "downloadButtonText padding-horizontal-14 ic-cta-button" },
                  _string_utility2.default.renderFormattedLabel("Sign up", "ic-cta-sign-up")
                )
              )
            )
          )
        );
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this10 = this;

      if ((0, _functional_utility.isNilOrEmpty)(this.state.data)) {
        return null;
      }
      var open = this.props.open;

      var customStyling = {
        display: open ? 'inline-block' : 'none',
        position: "absolute",
        zIndex: 100000
      };

      return _react2.default.createElement(
        _focusTrapReact2.default,
        { active: this.state.isDialogVisible },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "div",
            { "data-testid": "ic-widget", className: "ic-widget", style: customStyling },
            _react2.default.createElement(
              "div",
              { className: "icWidget" },
              _react2.default.createElement(
                _click_or_escape_outside2.default,
                { additionalClassName: "ic-overlay", id: "icWidget-outside",
                  isWidgetOpen: this.props.open,
                  tooltipRef: this.props.tooltip,
                  onClose: function onClose() {
                    _this10.trackOutsideWidgetGAEvent();
                    _this10.props.closeOverlay();
                    _this10.closeDisclosurePopup();
                    _this10.setState({ isDialogVisible: false });
                  } },
                _react2.default.createElement(
                  "div",
                  { className: "ic-overlay", "aria-modal": true, role: "dialog",
                    "aria-labelledby": "dialog-label",
                    onScroll: this.handleScroll, tabIndex: '0' },
                  this.renderStickyProductSelectorSection(),
                  _react2.default.createElement(
                    "button",
                    { id: "btn-ic-close",
                      "data-testid": "close-tooltip",
                      "aria-label": "Close",
                      className: "closeTip visible-outline-focus",
                      onClick: function onClick() {
                        _this10.trackCloseGAEvent();
                        _this10.props.closeOverlay();
                        _this10.closeDisclosurePopup();
                        _this10.setState({ isDialogVisible: false });
                      } },
                    _react2.default.createElement("span", { className: "crossImage" })
                  ),
                  this.renderFundsOverview(),
                  _react2.default.createElement(
                    "div",
                    { className: "ic-cards" },
                    this.renderPerformanceAndMorningstarRanks(),
                    this.renderGrowthOf10K(),
                    this.renderStatistics()
                  ),
                  this.renderCTASecond()
                )
              )
            )
          )
        )
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if ((0, _ramda.isNil)(props.icData) || (0, _functional_utility.isNilOrEmpty)(props.icData.figiIDs)) {
        return null;
      } else if ((0, _ramda.isNil)(state) || state.figiIDs.length !== props.icData.figiIDs.length) {
        if ((0, _ramda.isNil)(state) || state.figiIDs.length === 0) {
          return { data: props.icData.data, figiIDs: [props.icData.data[0].basicInfo.figiId] };
        } else {
          return { data: state.data, figiIDs: state.figiIDs };
        }
      }
      return null;
    }
  }]);

  return IcWidget;
}(_react2.default.Component);

exports.default = (0, _reactIntl.injectIntl)(IcWidget, { withRef: true });